import './LoserOffer.css';
import {useActions} from "../../../../hooks/useActions";
import {NutakuPaymentBrowserService} from "../../../../services/payments/NutakuPaymentBrowserService";
import {useTypedSelector} from "../../../../hooks/useTypedSelector";

function LoserOffer() {
    const {setRoute, setIsLoading} = useActions();

    const {isLoading, nutakuBoxes} = useTypedSelector(state => state.auth);

    return (
        <div className='loContiner' onClick={() => setRoute('home')}>
            <div className='loBannerContainer'>

                <div className='loCloseButton' onClick={() => {
                    setRoute('home');
                }}></div>

                <div
                    className='loButton defaultButtonAnimation_5'
                    onClick={() => {
                        if (isLoading) return;

                        setIsLoading(true);
                        NutakuPaymentBrowserService.start(nutakuBoxes[3]);
                    }}
                >
                </div>

            </div>
        </div>
    );
}

export default LoserOffer;